import "./app.scss";
import Routes from "./Routes";

function App(props) {
	return <Routes childProps={{ ...props }} />;
}

export default App;
